import React, { createContext, useContext, useEffect, useState, useRef } from 'react';

import { UNREAD_ONLY } from '../../utilities/constants.js';
import { isLoginUserPartnerCompany } from '../../utilities/roleUtility.js'

import FieldBulletinBoardsApi from './FieldBulletinBoardsApi';
import SessionStorageService from '../utilities/SessionStorageService.js';

const FieldBulletinBoardsUnreadCountCtx = createContext(0);

function FieldBulletinBoardsUnreadCountProvider({
  children,
}) {

  const [unreadCount, setUnreadCount] = useState(0);  
  const isPartnerCompanyUser = useRef(isLoginUserPartnerCompany());

  useEffect(() => {
    fetchUnreadCount();
  }, []);

  const fetchUnreadCount = () =>{
    if (isPartnerCompanyUser.current){
      const fieldId = SessionStorageService.getFieldId();
      // ログイン直後、現場選択前の場合処理終了
      if (fieldId === null) {
        return;
      }
      FieldBulletinBoardsApi.fetchFieldBulletinBoardList(
        fieldId,
        {
          unread_only: UNREAD_ONLY.CHECK,
          limit: 0
        })
        .then(response => {
          setUnreadCount(response.data.total);
        })
      }
      // エラーをユーザーに伝達する必要が無いため、catchは記載しない。
  }

  const getUnreadCount = () => {
    return unreadCount;
  }

  const contextValue = {
    getUnreadCount,
    fetchUnreadCount
  };

  return (
    <FieldBulletinBoardsUnreadCountCtx.Provider value={contextValue}>
      {children}
    </FieldBulletinBoardsUnreadCountCtx.Provider>
  );

}

const useFieldBulletinBoardUnreadCount = () => {
  return useContext(FieldBulletinBoardsUnreadCountCtx);
};

export { FieldBulletinBoardsUnreadCountProvider, useFieldBulletinBoardUnreadCount };



// WEBPACK FOOTER //
// ./src/services/fieldBulletinBoard/FieldBulletinBoardsUnreadCountContext.js